var map = {
	"./A.svg": 1331,
	"./B.svg": 432,
	"./ExamLocations.svg": 3525,
	"./Graduation.svg": 8362,
	"./OfferHoldersDay.svg": 2909,
	"./PrayerAndReflectionLG.svg": 8302,
	"./UofG_App_Logo.svg": 9811,
	"./af/individual_components.svg": 8082,
	"./af/s_graded.svg": 5187,
	"./af/s_notopen.svg": 7479,
	"./af/s_notsubmitted.svg": 4898,
	"./af/s_overdue.svg": 1032,
	"./af/s_submit.svg": 4712,
	"./af_course.svg": 6601,
	"./af_failure.svg": 252,
	"./af_overdue.svg": 3266,
	"./af_submitted.svg": 6293,
	"./af_success.svg": 9099,
	"./apple-app-store-badge.svg": 4226,
	"./bell.svg": 5853,
	"./br_down.svg": 8725,
	"./br_up.svg": 3994,
	"./capacity.svg": 5706,
	"./chevron-down-light.svg": 8391,
	"./circle-tick.svg": 8468,
	"./cleanDeep.svg": 6411,
	"./cleanMaterials.svg": 5997,
	"./club_img.svg": 9654,
	"./clubs/Academic.svg": 5089,
	"./clubs/Arts and Music.svg": 2052,
	"./clubs/Charity and Fundraising.svg": 7685,
	"./clubs/Crafts and Hobbies.svg": 3574,
	"./clubs/Environment and Nature.svg": 3957,
	"./clubs/Faith.svg": 468,
	"./clubs/Fiction and Fantasy.svg": 2761,
	"./clubs/Food and Drink.svg": 1409,
	"./clubs/Health and Wellbeing.svg": 8456,
	"./clubs/Languages and Culture.svg": 8876,
	"./clubs/Media and Broadcasting.svg": 7166,
	"./clubs/Other.svg": 2150,
	"./clubs/Political and Activism.svg": 428,
	"./clubs/Skills and Employability.svg": 1833,
	"./clubs/Sport.svg": 7182,
	"./clubs/Technology and Gaming.svg": 7408,
	"./defibrillator.svg": 4165,
	"./defibrillatorLG.svg": 7998,
	"./error_blue.svg": 6539,
	"./error_white.svg": 2286,
	"./event_bg.svg": 4060,
	"./event_img.svg": 1254,
	"./events-hmpg.svg": 5232,
	"./facemask.svg": 4845,
	"./far-chevron-down.svg": 952,
	"./far-chevron-left-disabled.svg": 8504,
	"./far-chevron-left-white.svg": 6871,
	"./far-chevron-left.svg": 8727,
	"./far-chevron-right-disabled.svg": 6315,
	"./far-chevron-right-white.svg": 5790,
	"./far-chevron-right.svg": 2418,
	"./find-a-building-hmpg.svg": 1969,
	"./gradeIcon.svg": 4672,
	"./greenTick.svg": 9300,
	"./group.svg": 3919,
	"./hw_counselling.svg": 665,
	"./hw_nightline.svg": 8320,
	"./hw_reporting.svg": 6910,
	"./hw_togetherall.svg": 7415,
	"./hw_wellbeing.svg": 3257,
	"./hw_wellbeing_lg_bkgnd.svg": 892,
	"./hw_wellbeing_sm_bkgnd.svg": 8607,
	"./index/deadline.svg": 8410,
	"./index/deadlines_grades.svg": 1955,
	"./index/expandChev.svg": 1921,
	"./index/hp_ass_feed.svg": 5690,
	"./index/hp_moodle.svg": 1076,
	"./index/hp_timetable.svg": 8085,
	"./index/link_booking.svg": 3433,
	"./index/location_details.svg": 1179,
	"./index/location_details_solid.svg": 3783,
	"./index/moodle.svg": 2085,
	"./index/on_campus.svg": 4234,
	"./index/online_live.svg": 6985,
	"./index/recorded.svg": 7913,
	"./index/room_booking.svg": 5836,
	"./index/see_moodle.svg": 2933,
	"./keydates/Academic.svg": 5012,
	"./keydates/Elections.svg": 9691,
	"./keydates/Enrolment.svg": 2415,
	"./keydates/Examination.svg": 4480,
	"./keydates/Graduation.svg": 2257,
	"./keydates/Revision.svg": 4018,
	"./keydates/Teaching.svg": 2772,
	"./keydates/Vacation.svg": 8596,
	"./maintenance.svg": 2127,
	"./map-hmpg.svg": 5003,
	"./no_internet.svg": 2585,
	"./noti-bell.svg": 3504,
	"./notif_bg.svg": 1038,
	"./period-productLG.svg": 3208,
	"./rag-amber.svg": 6446,
	"./rag-green.svg": 8430,
	"./rag-red.svg": 4254,
	"./redCross.svg": 2693,
	"./retail-outletLG.svg": 6352,
	"./social/facebook.svg": 9410,
	"./social/instagram.svg": 5046,
	"./social/twitter.svg": 8927,
	"./solid-burger-fries-slash.svg": 2133,
	"./studentsupportofficers.svg": 4737,
	"./support-and-wellbeing-hmpg.svg": 1088,
	"./voteEnd.svg": 5985,
	"./voteStart.svg": 8866,
	"./voting-icon.svg": 607,
	"./wellbeing-support-hmpg.svg": 7928
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1980;